import React from 'react';
import {observer} from "mobx-react";
import {OrbitComponent} from "../../base-components/orbit-component/orbit-component";
import {Link} from "../../raw-components/link/link";
import {Image} from "../../raw-components/image/image";

@observer
export class StoreButton extends OrbitComponent<{}> {
  render(): React.ReactNode {
    return (
      <div style={{textAlign: "center"}}>
        <Link href={this.services.configuration.data.sideMenu.store_button.appLink}
              preventDefaultOnClick={false}
              onClick={() => this._sendAnalytics()}>
          <Image src={this._getImageSource()} width={200} />
        </Link>
      </div>
    );
  }

  private _sendAnalytics() {
    if(this.services.device.os.isIOS) {
      this.services.analytics.sendAnalytics('Navigation', 'App', 'Open_AppStore');
    } else {
      this.services.analytics.sendAnalytics('Navigation', 'App', 'Open_GooglePlay');
    }
  }

  private _getImageSource(): string {
    const config = this.services.configuration.data.sideMenu.store_button;
    if(config.imgSrc.includes('{lang}')) {
      return config.imgSrc.replace('{lang}', this.services.language.currentLanguage)
    }

    return config.imgSrcFallback;
  }
}
